module.exports = __webpack_public_path__ + "img/giuliana-margaria.c283957d.jpg";